<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtkey"  placeholder="招标项目名称/项目编号" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time"></el-form-item>

        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="招标项目名称" prop="zbproname" min-width="180" fixed="left"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode" min-width="120"></el-table-column>
            <el-table-column label="采购执行单位" min-width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.zbdljgname">{{scope.row.zbdljgname}}</span>
                    <span v-else>{{scope.row.xmzbrname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="关联方案" >
                <template slot-scope="scope">
                    <span v-if="scope.row.relationproname">{{scope.row.relationproname}}({{scope.row.customcode}})</span>
                </template>
            </el-table-column>
            <el-table-column label="招标方式" prop="zbfsname"></el-table-column>
            <el-table-column label="招标组织形式" prop="zbzzxsname"></el-table-column>
            <el-table-column label="操作" min-width="120" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination 
            ref="page" 
            v-model="tableData" 
            :search="pgData" 
            :action="`${getGetters('mngUrl')}/zbr/ZbrProject/get_list.json`">
        </my-pagination>
        
        <!--添加弹窗-->
        <el-dialog
            title="选择项目类型"
            :visible.sync="addDialogVisible"
            width="30%">
            
            <el-row :gutter="48">
                <el-col :span="12">
                    <div class="con" @click="linklist('zfcg')">
                        <i class="el-icon-date"></i>
                        <p>政府采购</p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="con" @click="linklist('zxcg')">
                        <i class="el-icon-user"></i>
                        <p>自行采购</p>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import BTN_CONF from './config/btn-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {},
    data() {
        return{
            pgData: {
                txtkey:'',
                sortname:'zbprocode'
            },
            BTN_CONF,
            // 弹窗设置
            addDialogVisible:false,
            orgcode:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        linklist(val){
            this.goto({
                path: '/bidding/zbr/zbproject/linklist',
                query: {
                    type: val,
                }
            });
        }
    },
    created() {
        this.orgcode = getSession('user').orgcode
        console.log(this.orgcode)
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
    .con{ padding: 10px;  text-align: center; cursor: pointer; }
    .con i{ font-size: 56px; color: #409eff; }
    .con p{ margin-top: 15px; font-size: 16px;}
</style>
